import * as React from 'react'
import { Box, Toolbar, Typography } from '@material-ui/core'
import PurpleFront from '../assets/purple_front.png';

type MobilePreviewViewProps = {
    children: JSX.Element,
    title?: string,
}

const MobilePreviewView = ({ children, title }: MobilePreviewViewProps) => {
    return <Box flexShrink={0} style={{ height: '756px', position: 'relative', borderLeft: '1px solid #e1e1e1', padding: '16px 0 0 16px', boxSizing: 'border-box' }}>
        <Box width="375px" height="100%">
            <Toolbar style={{ backgroundColor: '#fff', marginTop: '24px' }}>
                <Typography style={{ width: '100%' }} variant="h6" align="center">{title}</Typography>
            </Toolbar>
            <Box style={{ paddingLeft: '20px', paddingRight: '24px', height: 'calc( 100% - 110px )', overflow: 'auto' }}>
                {children}
            </Box>
        </Box>
        <img style={{ width: '375px', position: 'absolute', top: 0, pointerEvents: 'none' }} src={PurpleFront} />
    </Box>
}
export default MobilePreviewView